module.exports = __webpack_public_path__ + "a60dd1891d00d5378bfd1718477560c8.jpg";